import I18n from 'I18n';
import { useCallback, useContext } from 'react';

// @ts-expect-error module not typed
import { getSubject } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SubjectInput from './SubjectInput';
import MetadataInputLabel from './MetadataInputLabel';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
// @ts-expect-error module not typed
import { setCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplySetters';
import { updateEmailSubject } from 'conversations-thread-data/common-reply/public/operators/updateEmailSubject';
import { getSubjectChanged } from '../../../usage-tracking/events/metadataEditorInteractions';
import debounce from 'hs-lodash/debounce';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';

/**
 * Track an interaction event ("subject-changed") when bound to onChange events
 * of a text field. Any change to the subject must be at least 2.5 seconds
 * after the previous change to trigger.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const debouncedUsageTracker = debounce(trackEvent => trackEvent(getSubjectChanged()), 2500, {
  trailing: false,
  leading: true
});
export const Subject = ({
  reply,
  onChange,
  handleSetExpanded,
  settings
}) => {
  const commonMessage = getCommonMessage(reply);
  const subject = getSubject(commonMessage) || '';
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const handleSubjectChange = useCallback(nextSubject => {
    const updatedCommonMessage = updateEmailSubject(nextSubject, commonMessage);
    const replyWithSubject = setCommonMessage(updatedCommonMessage, reply);
    onChange(replyWithSubject);
    debouncedUsageTracker(trackEvent);
  }, [onChange, reply, commonMessage, trackEvent]);
  return /*#__PURE__*/_jsx(MetadataInputLabel, {
    label: I18n.text('composer-ui.metadata-editor.subject.label'),
    "data-selenium-test": "metadata-subject-input",
    children: /*#__PURE__*/_jsx(SubjectInput, {
      value: subject || '',
      onChange: handleSubjectChange,
      onFocus: handleSetExpanded,
      settings: settings
    })
  });
};
Subject.displayName = 'Subject';